<template>
    <van-popup teleport=".wrapper" v-model="show" :close-on-click-overlay='false'
        :overlay-style="{ backdropFilter: 'blur(10px)' }">
        <!-- <div class="bailu">
        </div> -->
        <div id="merrywrap" class="merrywrap flex fd-c ai-c jc-c" :class="`step-${step}`">
            <div @click="open()" class="giftbox">
                <div class="cover"></div>
                <div class="box"></div>
            </div>
            <div class="star-list">
                <div class="row flex" v-for="(item, index) in 4" :key="index">
                    <div v-for="(im, ix) in 11" class="star" :style="starStyle(index, ix)" :key="ix">
                        <img src="@/assets/images/xingxing.png" alt="">
                    </div>
                </div>
            </div>
            <div class="prizePop">
                <div class="cancel" @click="cancel"></div>
                <div class="popTitle">恭喜获得</div>
                <div class="prizeList">
                    <div class="item" v-for="(item,index) in drawList" :key="index">
                        <div class="icon" v-if="item.url">
                            <div v-show="item.prizeId == 3" class="identification">农行专属</div>
                            <img :src="item.url" alt="">
                        </div>
                        <div>
                            <div class="name">{{ item.name }}</div>
                            <div class="introduce">{{ item.tips }}</div>
                            <div v-show="item.prizeId == 3" class="tips">中国农业银行APP专属</div>
                        </div>
                        
                        <div class="pick-bt" @click="jump(item)"></div>
                    </div>
                </div>
                <div class="view-bt" @click="jumpView"></div>
            </div>
            <codePop ref="codePop" :selectModel="selectModel"  />
        </div>
        <!-- <div class="content">

            <div class="pack" v-show="!open">
                <div class="xingxing1"></div>
                <div class="xingxing2"></div>
                <div class="xingxing3"></div>
                <div class="hezi1" @click="open = true">
                    <div class="hezi2"></div>
                </div>
            </div>
            <div class="prizePop" v-show="open">
                <div class="cancel" @click="cancel"></div>
                <div class="popTitle">恭喜获得</div>
                <div class="prizeList">
                    <div class="item" v-for="(item,index) in drawList" :key="index">
                        <div class="icon" v-if="item.url">
                            <div v-show="item.prizeId == 3" class="identification">农行专属</div>
                            <img :src="item.url" alt="">
                        </div>
                        <div>
                            <div class="name">{{ item.name }}</div>
                            <div v-show="item.prizeId == 3" class="tips">中国农业银行APP专属</div>
                        </div>
                        
                        <div class="pick-bt"></div>
                    </div>
                </div>
                <div class="view-bt" @click="jump"></div>
            </div>
        </div> -->
    </van-popup>
</template>

<script>
import codePop from '../prize/codePop.vue'
import {prizeDraw} from '@/api'
export default {
    components: {
        codePop
    },
    props: ['prizeImg'],
    data() {
        return {
            drawList:[],
            selectModel:{},
            show: false,
            step: 0   //重置为0 
        };
    },
    watch: {
    },
    computed: {},
    methods: {
        jump(item){
            if(item.exchangeType == 2){
                this.$refs.codePop.show = true
                this.selectModel = item
                return
            }
            let link = item.link
            this.$ixmWebView(link)
            // let applicationType = ''  //渠道：1->APP；2->市民卡；3->PC；4->公众号
            // let ua = navigator.userAgent.toLowerCase()
            // if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //     applicationType = 4
            // } else if (ua.match(/xmsmk/i) == "xmsmk") {
            //     applicationType = 2
            // } else {
            //     applicationType = 1
            // } 
            // let link = item.link
            // if (link.indexOf('APP:') != -1) {
            //     window.location.href = link.split('APP:')[1]
            // }else{
            //     if(applicationType == 2){
            //         var uas = navigator.userAgent;
            //         let preloadJs = function() {
            //         // Promise语法是ES6⽀持的，其他不⽀持的请⾃⾏转成ES5
            //         return new Promise((resolve, rejct) => {
            //             if (uas.toLowerCase().indexOf("xmsmk") !== -1) {
            //             if (window.UmsApi === undefined) {
            //                 document.addEventListener(
            //                 "OnUmsApiReady",
            //                 function() {
            //                     resolve(true);
            //                 },
            //                 false
            //                 );
            //             } else {
            //                 resolve(true);
            //             }
            //             } else {
            //             // ⾮市⺠卡接⼊
            //             reject("⾮市⺠卡接⼊");
            //             }
            //         });
            //         };
            //         preloadJs().then(res=>{
            //             var url = link.split('LINK:')[1]
            //             UmsApi.system.openWebPage.bySelf(url)

            //         })

            //     } else if(applicationType == 1){
            //         CityBridge.openWindow({
            //             url:link.split('LINK:')[1]
            //         })
            //     }

            // }

        },
        pick(item){
            if(item.exchangeType == 2){
                this.selectModel = item
                this.$refs.codePop.show = true
            }else{
                location.href = item.like
            }


        },
        cancel(){
            this.show = false
            setTimeout(()=>{
                this.step = 0
            },1000)

        },
        jumpView(){
            this.$router.push({
                path:'/prize'
            })


        },
        starStyle(rowIndex, index) {
            if (this.step == 1||this.step == 0) {
                return {
                    // transform:`translateY(${1000 - (rowIndex*100)}%) translateX(${500 - (index*100)}%)`
                    transform:`translateY(calc(50vh - 0.5rem - ${rowIndex*100}%)) translateX(${500 - (index*100)}%)`
                }
            } else if (this.step == 2) {
                return {
                    transform:`translateY(-500%)`,
                    opacity: 1,
                    transitionDelay: `${0.1 + (rowIndex * 0.05)}s`
                }
            }
        },
        //开奖请求
        request() {
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(200);
                }, 100)
            })
        },
        //打开礼盒  无需修改
        async open() {
            let that = this
            if (this.step != 0) return false
            this.step = 1
            let res = await prizeDraw()
            if (res.data.code == 200) {
                //开启动画
                // setTimeout(() => {
                //     this.step = 2
                // }, 1500)
                console.log('失败1')
                let data = res.data.data
                data.forEach(ele=>{
                    that.prizeImg.forEach(item=>{
                        if(ele.prizeId == item.id){
                            that.drawList.push({
                                ...ele,
                                link:ele.url,
                                url:item.url
                            })
                        }
                        
                    })
                    
                })
                console.log('失败2')
                setTimeout(() => {
                    that.step = 2
                }, 1500)
                console.log('失败3')
                that.$emit('details')
            } else {
                console.log('失败')
                this.step = 0
                this.$tost('打开失败，请重新打开')
            }

        }
    },
    created() { },
    mounted() {
    },
};
</script>
<style scoped lang="scss">
.identification{
    width: 1.05rem;
    height: .3rem;
    line-height: .3rem;
    border-radius: .3rem;
    background-color: #399789;
    color: #fff;
    font-size: .21rem;
    text-align: center;
    font-family: SourceHanSansCNMedium;
    position: absolute;
    top: -.15rem;
}
.van-popup {
    /* width: 100% !important;
    height: 100vh !important;
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    height: 6.1rem; */
    background-color: transparent;
    position: fixed;
    z-index: 501;
    width: 100vw;
    height: 100vh;

}

.merrywrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;

    .giftbox {
        width: 3.92rem;
        height: 3.75rem;
        position: absolute;
        z-index: 10;
        cursor: pointer;

        .cover {
            position: absolute;
            top: 0;
            left: 0;
            width: 3.72rem;
            height: 2.18rem;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/cover.png);
            background-size: 100% 100%;
            z-index: 2;
        }

        .box {
            position: absolute;
            width: 3.92rem;
            height: 2.9rem;
            bottom: 0;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/box.png);
            background-size: 100% 100%;
            left: .1rem;
            z-index: 1;
        }
    }
    .cancel {
        width: .39rem;
        height: .49rem;
        background-size: 100% auto;
        background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/cancel.png);
        position: absolute;
        top: -.4rem;
        right: .2rem;
    }

    .prizePop {
        width: 6.54rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        transform:translateY(-100vh) scale(0.5);
        transition: transform 0.3s ease-in;
        .popTitle {
            width: 100%;
            height: .54rem;
            line-height: .54rem;
            text-align: center;
            color: #fff;
            font-family: DingTalkJinBuTi;
            font-size: .46rem;

        }

        .view-bt {
            width: 4.29rem;
            height: 1.4rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/view-bt.png);
            margin-top: .4rem;

        }

        .prizeList {
            width: 6.54rem;
            max-height: 60vh;
            overflow-y: scroll;
            padding: .23rem 0;
            background-color: #fff;
            border-radius: .65rem;
            margin-top: .56rem;
            display: flex;
            flex-direction: column;
            align-items: center;

            .item {
                width: 6.08rem;
                min-height: 1.91rem;
                display: flex;
                align-items: center;
                border-top: .02rem solid rgba(211, 211, 211, 0.77);

                .tips {
                    width: 2.44rem;
                    height: .35rem;
                    line-height: .35rem;
                    color: #9D9D9D;
                    font-size: .24rem;
                    margin-top: .16rem;
                    margin-left: .14rem;

                }

                .pick-bt {
                    width: 1.96rem;
                    height: 1rem;
                    background-size: 100% auto;
                    background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/pick-bt.png);
                    margin-left: .14rem;
                    background-position: top;
                    background-repeat: no-repeat;
                }



                .icon {
                    width: 1.54rem;
                    min-height: 1.54rem;
                    position: relative;
                    display: flex;
                    justify-content: center;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .name {
                    width: 2.21rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: .33rem;
                    color: #194769;
                    font-family: DingTalkJinBuTi;
                    margin-left: .23rem;
                }
                .introduce{
                    width: 2.21rem;
                    font-size: .33rem;
                    color: #194769;
                    font-family: DingTalkJinBuTi;
                    margin-left: .23rem;
                }

            }

            .item:nth-child(1) {
                border: none;
            }
        }
    }


    .pack {
        width: 5.33rem;
        height: 5.33rem;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        .xingxing1 {
            width: 2.21rem;
            height: 2.21rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/xingxing.png);
            position: absolute;
            left: -1rem;
            top: -.6rem;

        }

        .xingxing2 {
            width: .6rem;
            height: .6rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/xingxing.png);
            position: absolute;
            right: 0rem;
            top: 1rem;
        }

        .xingxing3 {
            width: 1.47rem;
            height: 1.47rem;
            background-size: 100% auto;
            background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/xingxing.png);
            position: absolute;
            right: -.2rem;
            top: 3.5rem;
        }



        // .hezi1 {
        //     width: 3.92rem;
        //     height: 2.9rem;
        //     background-size: 100% auto;
        //     background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/hezi1.png);
        //     position: relative;

        //     .hezi2 {
        //         width: 3.72rem;
        //         height: 2.18rem;
        //         background-size: 100% auto;
        //         background-image: url(https://ixm-2023up-hspeed.oss-cn-shenzhen.aliyuncs.com/year/hezi2.png);
        //         position: absolute;
        //         top: -.8rem;
        //         left: -.1rem;
        //     }
        // }
    }

}

.star-list {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 11;
    position: absolute;
    pointer-events: none;

    .row {
        width: 100%;
    }

    .star {
        width: calc((100% / 11));
        text-transform: uppercase;
        transition: transform 0.3s ease-in, opacity 0.1s;
        opacity: 0;

        img {
            width: 100%;
        }
    }
}

/* .step-1 */
.step-1 {
    .giftbox {
        animation: wobble 0.5s linear infinite forwards;
    }

    .giftbox .cover {
        animation: wobble 0.5s 0.1s linear infinite forwards;
    }

}


/* .step-1 */

/* Step 2 */
.step-2 {
    .giftbox .cover {
        animation: flyUp 0.4s ease-out forwards;
    }

    .giftbox .box {
        animation: fallDown 1.5s 0.05s ease-in forwards;
    }
    .prizePop{
        transform:translateY(0vh) scale(1);
        transition-delay: 1s;
    }
}

/* Step 2 */

@-webkit-keyframes wobble {
    25% {
        -webkit-transform: rotate(4deg);
    }

    75% {
        -webkit-transform: rotate(-2deg);
    }
}

@-webkit-keyframes wobble {
    25% {
        -webkit-transform: rotate(4deg);
    }

    75% {
        -webkit-transform: rotate(-2deg);
    }
}

@-webkit-keyframes fallDown {
    75% {
        opacity: 1;
    }

    100% {
        -webkit-transform: translateY(1000px);
        opacity: 0;
    }
}

@-webkit-keyframes flyUp {
    75% {
        opacity: 1;
    }

    100% {
        -webkit-transform: translateY(-1000px) rotate(20deg);
        opacity: 0;
    }
}


.content {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    
}


/* .bailu{
    width: 5.09rem;
    height: 4.99rem;
    background-image: url(../../assets/images/tipsPop.png);
    background-size: 100% auto;
    background-position: bottom;
    background-repeat: no-repeat;
    position: relative;
    display: flex;
    justify-content: center;
    position: relative;
} */</style>